import { Component, OnInit, inject } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { ConfigurablePageComponent } from 'src/app/core/abstracts/configurable-page.component'
import { RoutePaths } from 'src/app/core/data/route-paths.data'
import { IAsset } from 'src/app/core/interfaces/asset.interface'
import { FilterId } from 'src/app/core/interfaces/filter.interface'
import { ChipsService } from 'src/app/core/services/chips.service'
import { FilterService } from 'src/app/core/services/filter.service'
import { LogService } from 'src/app/core/services/log.service'
import { GlobalDataService } from 'src/app/core/services/global-data.service'


@Component({
  selector: 'app-search-redirect-page',
  template: ``,
})
export class SearchPageRedirectorComponent extends ConfigurablePageComponent implements OnInit {
  private _logger = inject(LogService)
  private _route = inject(ActivatedRoute)
  private _router = inject(Router)
  protected _filterService = inject(FilterService)
  protected _chipService = inject(ChipsService)
  protected _globalDataService = inject(GlobalDataService)

  assets!: IAsset[]
  FilterId = FilterId

  ngOnInit() {
    // This can be used to populate filters for specific urls, e.g. /equipment/search/category/Dozers/subcategory/0-114 HP Crawler Dozers
    // Add additional support below for other combos and set it up in the search-page router
    this._filterService.clearFilterState()
    this._chipService.clearChips()
    this.tryCategorySubcategoryRedirect()
    this.tryMakeModelRedirect()
    this.tryCountryStateCityRedirect()
    this._router.navigate([RoutePaths.Search], {
      queryParams: {
        filters: this._filterService.encodeFilters(this._filterService.getFiltersWithState()),
      },
      replaceUrl: true,
    })
  }

  getParam(key: string): string | null {
    const value = this._route.snapshot.paramMap.get(key)
    return value ? decodeURIComponent(`${value}`) : null
  }

  tryCategorySubcategoryRedirect() {
    const category = this.getParam('category')
    const subcategory = this.getParam('subcategory')
    if (category && subcategory) {
      this._filterService.updateFilter(FilterId.CatSubcat, [{
        value: category,
        field: 'category',
        parentId: null,
      }, {
        value: subcategory,
        field: 'sub_category',
        parentId: `category|${category}`,
      }])
      this._globalDataService.searchExpandCategory.set(true)
    } else if (category) {
      this._filterService.updateFilter(FilterId.CatSubcat, [{
        value: category,
        field: 'category',
        parentId: null,
      }])
      this._globalDataService.searchExpandCategory.set(true)
    } else if (subcategory) {
      const settings = this._filterService.filterSettings.category
      const parent = settings.find(s => s.children?.find(c => c.value === subcategory))
      if (!parent) {
        this._logger.error('Could not find category for subcategory', subcategory)
        return
      }
      this._filterService.updateFilter(FilterId.CatSubcat, [{
        value: parent.value,
        field: 'category',
        parentId: null,
      }, {
        value: subcategory,
        field: 'sub_category',
        parentId: `category|${parent.value}`,
      }])
      this._globalDataService.searchExpandCategory.set(true)
    }
  }

  tryMakeModelRedirect() {
    const make = this.getParam('make')
    const model = this.getParam('model')
    if (make && model) {
      this._filterService.updateFilter(FilterId.MakeModel, [{
        value: make,
        field: 'make',
        parentId: null,
      }, {
        value: model,
        field: 'model',
        parentId: `make|${make}`,
      }])
      this._globalDataService.searchExpandMake.set(true)
    } else if (make) {
      this._filterService.updateFilter(FilterId.MakeModel, [{
        value: make,
        field: 'make',
        parentId: null,
      }])
      this._globalDataService.searchExpandMake.set(true)
    } else if (model) {
      const settings = this._filterService.filterSettings.make
      const parent = settings.find(s => s.children?.find(c => c.value === model))
      if (!parent) {
        this._logger.error('Could not find make for model', model)
        return
      }
      this._filterService.updateFilter(FilterId.MakeModel, [{
        value: parent.value,
        field: 'make',
        parentId: null,
      }, {
        value: model,
        field: 'model',
        parentId: `make|${parent.value}`,
      }])
      this._globalDataService.searchExpandMake.set(true)
    }
  }

  tryCountryStateCityRedirect() {
    const country = this.getParam('country')
    const state = this.getParam('state')
    const city = this.getParam('city')
    if (country && state && city) {
      this._filterService.updateFilter(FilterId.Location, [{
        value: country,
        field: 'branch_country',
        parentId: null,
      }, {
        value: state,
        field: 'branch_state',
        parentId: `branch_country|${country}`,
      }, {
        value: city,
        field: 'branch_city',
        parentId: `branch_state|${state}`,
      }])
    } else if (country && state) {
      this._filterService.updateFilter(FilterId.Location, [{
        value: country,
        field: 'branch_country',
        parentId: null,
      }, {
        value: state,
        field: 'branch_state',
        parentId: `branch_country|${country}`,
      }])
    } else if (country) {
      this._filterService.updateFilter(FilterId.Location, [{
        value: country,
        field: 'branch_country',
        parentId: null,
      }])
    }
  }
}
